import React from 'react';
import './CTA.scss';

const CTA: React.FC = () => {
  return (
    <section className="cta" id="cta">
      <div className="cta__container">
        <div className="cta__content">
          <div className="cta__badge">
            <i className="fas fa-gift"></i>
            <span>7 dias grátis + Setup sem custo</span>
          </div>
          
          <h2 className="cta__title">
            Comece sua transformação digital <span className="cta__highlight">hoje mesmo</span>
          </h2>
          
          <p className="cta__description">
            Junte-se a mais de 500 empresas que já automatizaram sua gestão 
            e aumentaram sua produtividade em mais de 40%. Sem burocracia, 
            sem permanência mínima, sem cartão de crédito.
          </p>
          
          <div className="cta__features">
            <div className="cta__feature">
              <i className="fas fa-check-circle"></i>
              <span>Ativação imediata</span>
            </div>
            <div className="cta__feature">
              <i className="fas fa-check-circle"></i>
              <span>Suporte premium incluso</span>
            </div>
            <div className="cta__feature">
              <i className="fas fa-check-circle"></i>
              <span>Cancele quando quiser</span>
            </div>
          </div>
          
          <div className="cta__buttons">
            <a 
              href="https://app.77gestao.com.br/cadastro?source=cta" 
              className="cta__button cta__button--primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-rocket"></i>
              Começar teste grátis agora
            </a>
            <a 
              href="/funcionalidades" 
              className="cta__button cta__button--secondary"
            >
              <i className="fas fa-list"></i>
              Ver funcionalidades
            </a>
          </div>
          
          <div className="cta__trust">
            <div className="cta__trust-item">
              <i className="fas fa-shield-alt"></i>
              <span>Segurança e privacidade garantidas</span>
            </div>
            <div className="cta__trust-item">
              <i className="fas fa-headset"></i>
              <span>Suporte humano em até 1 hora</span>
            </div>
          </div>
          
          <p className="cta__urgency">
            <i className="fas fa-fire"></i>
            <strong>Última chance:</strong> Poucas vagas disponíveis para onboarding premium por mês
          </p>
        </div>
        
        <div className="cta__decoration">
          <div className="cta__circle cta__circle--1"></div>
          <div className="cta__circle cta__circle--2"></div>
          <div className="cta__circle cta__circle--3"></div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
